<template>
  <el-container class="layout-container">
    <el-main class="layout-main">
      <div class="bg">
        <div class="layout-header slide-in-top">
          <div class="layout-sitename">
            <div class="site-name">{{ siteName }}</div>
          </div>
        </div>
      </div>
      <div class="layout-menu">
        <div class="menus">
          <div class="menusBox">
            <div
              class="menu-item"
              :class="{ active: checkIsActive(item) }"
              v-for="item in newMenus"
              :key="item.id"
              @click="onMenuClick(item)"
              @mouseenter="mouseIn(item)"
            >
              <svg-icon
                v-if="item.icon"
                :icon-name="item.icon"
                icon-class="menu-icon"
                :active="item.code === current || mouseCurrent == item.code"
                iconColor="rgba(23, 150, 107, 1)"
              ></svg-icon>
              <div class="menu-label">{{ item.name }}</div>
              <div
                class="test"
                @mouseleave="mouseOut(item)"
                v-if="
                  item.subMenusShow && item.children && item.children.length > 0
                "
              >
                <div class="itembox">
                  <div
                    class="sub-menu-item"
                    :class="{ active: v.code === current }"
                    v-for="(v, i) in item.children"
                    :key="v.id"
                    @click="onSubMenuClick(v)"
                  >
                    <div class="subMenusBg">
                      <div class="subMenusName">{{ v.name }}</div>
                    </div>
                    <div
                      class="line"
                      v-if="i != item.children.length - 1"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="layout-info slide-in-top">
        <div class="account">
          <div class="iconBoxG">
            <svg-icon icon-name="system" class="infoIcon"></svg-icon>
          </div>
<!--          <span class="pointer fluorescent_green" @click="onAdmin"-->
<!--            >后台管理</span-->
          >
        </div>

        <div class="account">
          <div class="iconBoxG">
            <svg-icon icon-name="account"></svg-icon>
          </div>
          <span>{{ username }}</span>

          <div
            class="pointer fluorescent_green"
            style="margin-left: 15px"
            @click="onLogout"
          >
            退出
          </div>
        </div>
      </div>
      <div class="underLayer">
        <ol-map :timelines="[]" :rollerShow="false" :toolbarShow="false">
          <ol-view
            :zoom="14"
            :extent="extent"
            :padding="[20, 0, 20, 0]"
          ></ol-view>
        </ol-map>
      </div>
      <router-view :key="$route.name" v-if="query"></router-view>
    </el-main>
  </el-container>
</template>

<script>
import { mapState } from "vuex";
import {
  getAllProduct,
  getAllRegion,
  getAllFeature,
  getAllFeatureList,
  getDicts,
  getPersonal,
  getCode,
  getRemind,
} from "@/api/common";
import { listToTree } from "@/utils/tools";
import axios from "axios";
import { login } from "@/api/login";
import {
  setCookieWithResidueTime,
  getCookie,
  delCookie,
} from "@/utils/setCookie";
export default {
  name: "AppLayout",

  computed: {
    ...mapState(["menus"]),

    subMenus() {
      const menu = this.menus.find((item) => item.code === this.current);
      return menu.children;
    },
  },
  watch: {
    current() {
      return this.$route.meta.module;
    },

    $route: {
      async handler(route) {
        if (route.meta.module === "farming") {
          const { regionId, featureId } = route.query;
          this.reminds = await getRemind({ regionId, cropId: featureId });
          this.needRemind = this.reminds.length > 0;
        } else {
          this.needRemind = false;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    //集成登录用这个
    // this.init();
    // this.onLogin();
    //不集成登录用这个
    this.initMenu();
    this.$bus.$on("extentChange", (data) => {
      this.extent = data;
    });
  },

  data() {
    return {
      needRemind: false,
      showRemind: false,
      reminds: [],
      siteName: process.env.VUE_APP_TITLE,
      admin: process.env.VUE_APP_ADMIN,
      screen: process.env.VUE_APP_SCREEN === "true",
      current: this.$route.meta.module,
      username: "",
      newMenus: [],
      mouseCurrent: "",
      query: "",
      extent: [
        114.74849724873528, 34.751361587871195, 114.8029835201403,
        34.78900993621989,
      ],
      formData: {
        username: "",
        password: "",
        verify: true,
      },
      menuTimeout: null,
    };
  },

  methods: {
    checkIsActive(item) {
      if (item.code == this.current) {
        return true;
      }
      if (item.children && item.children.length > 0) {
        let arr = item.children.filter((v) => v.code == this.current);
        if (arr.length > 0) {
          return true;
        }
      }
      return false;
    },
    onMenuClick(payload) {
      if (payload.children && payload.children.length > 0) {
        payload.subMenusShow = true;
      } else {
        this.current = payload.code;
        this.onSubMenuClick(payload);
      }
    },
    mouseIn(payload) {
      this.newMenus.forEach((item) => {
        item.subMenusShow = false;
      });
      payload.subMenusShow = true;
    },

    mouseOut(payload) {
      // if(this.menuTimeout )clearTimeout(this.menuTimeout )
      // this.menuTimeout = setTimeout(() => {
      //   payload.subMenusShow = false
      // }, 1000)
      payload.subMenusShow = false;
    },

    onSubMenuClick({ id, route, code }) {
      this.current = code;
      this.query.productId = id;
      if (route.startsWith("report")) {
        this.query = {};
      }
      localStorage.setItem("query", JSON.stringify(this.query));
      this.$router.push({ name: route });
    },
    clickOut(item) {
      item.subMenusShow = false;
    },
    onAdmin() {
      const token = localStorage.getItem("token");
      const refreshToken = localStorage.getItem("refreshToken");
      window.open(`${this.admin}?token=${token}&refreshToken=${refreshToken}`);
    },

    onLogout() {
      this.$confirm("此操作将退出系统, 是否继续?", "确认操作", {
        type: "info",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        customClass: "logout-confirm",
      })
        .then(() => {
          //集成登录
          // delCookie("kefuToken");
          // let baseUrl = localStorage.getItem("oldUrl");
          // window.location.href = baseUrl + "login.html";
          this.$router.push({ name: "login" });
        })
        .catch(() => {});
    },

    init() {
      //检测客户系统是否过期
      let oldUrl = this.$route.query.oldUrl;
      let cookieToken = this.$route.query.coo;
      if (oldUrl && cookieToken) {
        let baseUrl = oldUrl.substring(0, oldUrl.lastIndexOf("/") + 1);
        localStorage.setItem("oldUrl", baseUrl);
        const timestamp = 30 * 60 * 1000;
        setCookieWithResidueTime("kefuToken", cookieToken, timestamp);
        setTimeout(() => {
          let url = window.location.href;
          let first = url.split("?")[0];
          window.location.href = first;
        }, 100);
      } else {
        let kefuTokenStorage = getCookie("kefuToken");
        if (!kefuTokenStorage) {
          let baseUrl = localStorage.getItem("oldUrl");
          window.location.href = baseUrl + "login.html";
        } else {
          axios({
            method: "get",
            url: "/kuhu/henan/nolog/account/checkUserLogin",
            headers: {
              Accesstoken: kefuTokenStorage,
            },
          }).then((res) => {
            let flag = res.data.flag;
            let data = res.data.data;
            if (flag) {
              this.username = data.personName;
            } else {
              this.username = "";
            }
          });
        }
      }
    },
    async onLogin() {
      // 登录
      const { data } = await login(this.formData);
      if (!data) {
        this.errorTip("用户名或密码错误");
        this.$waiting.hidden();
        return;
      }
      // 设置 token
      localStorage.setItem("token", data.accessToken);
      localStorage.setItem("refreshToken", data.refreshToken);

      // 获取菜单
      let { data: products } = await getAllProduct();
      products = products.filter((item) => item.remark == "land");
      const productTree = listToTree(products);
      let routeName = "";
      let productId = "";
      localStorage.setItem("menus", JSON.stringify(productTree));
      if (productTree[0].children) {
        localStorage.setItem("defaultProductId", productTree[0].children[0].id);
        routeName = productTree[0].children[0].route;
        productId = productTree[0].children[0].id;
      } else {
        localStorage.setItem("defaultProductId", productTree[0].id);
        routeName = productTree[0].route;
        productId = productTree[0].id;
      }
      this.$store.commit("setMenus", productTree);
      let menus = productTree;
      menus.forEach((v) => {
        this.$set(v, "subMenusShow", false);
      });
      this.newMenus = menus;

      //获取字典
      const { data: dicts } = await getDicts({
        pageNo: 1,
        pageSize: 100,
        dictType: "equip_type",
      });
      const equipDictsDict = {};
      dicts.list.forEach((v) => {
        equipDictsDict[v.value] = v.label;
      });

      localStorage.setItem("equipDictsDict", JSON.stringify(equipDictsDict));
      localStorage.setItem("equipDictsArr", JSON.stringify(dicts.list));

      // 获取区域
      const { data: regions } = await getAllRegion();
      const regionsDict = {};
      regions.forEach((item) => {
        item.label = item.name;
        regionsDict[item.id] = item.name;
      });
      const regionTree = listToTree(regions);
      localStorage.setItem("regions", JSON.stringify(regionTree));
      localStorage.setItem("regionsDict", JSON.stringify(regionsDict));
      localStorage.setItem("defaultRegionId", regions[0].id.toString());
      this.$store.commit("setRegions", regionTree);

      //获取所有地物列表
      const { data: featuresList } = await getAllFeatureList({
        code: null,
        name: null,
      });
      const allfeaturesDict = {};
      featuresList.forEach((item) => {
        item.label = item.name;
        allfeaturesDict[item.id] = item.name;
      });
      const allfeatureTree = listToTree(featuresList);
      localStorage.setItem("allfeaturesDict", JSON.stringify(allfeaturesDict));
      localStorage.setItem("allfeatures", JSON.stringify(allfeatureTree));
      // 获取地物
      const { data: features } = await getAllFeature();
      const featuresDict = {};
      features.forEach((item) => {
        item.label = item.name;
        featuresDict[item.id] = item.name;
      });
      const featureTree = listToTree(features);
      localStorage.setItem("featuresDict", JSON.stringify(featuresDict));
      localStorage.setItem("features", JSON.stringify(featureTree));
      if (featureTree[0].children) {
        localStorage.setItem("defaultFeatureId", featureTree[0].children[0].id);
      } else {
        localStorage.setItem("defaultFeatureId", featureTree[0].id);
      }
      this.$store.commit("setFeatures", featureTree);
      let code = this.$route.meta.module;
      let arr1 = this.findRouteCode(this.newMenus, code);
      const query = {
        productId: arr1.id,
        regionId: regions[0].id.toString(),
      };
      if (routeName.startsWith("land")) {
        query.featureId = -1;
      } else if (
        !routeName.startsWith("warning") &&
        !routeName.startsWith("monitor")
      ) {
        query.featureId = featureTree[0].children[0].id;
      }
      this.query = query;
      localStorage.setItem("query", JSON.stringify(query));
    },
    findRouteCode(tree, code) {
      // 遍历树中的每个节点
      for (let i = 0; i < tree.length; i++) {
        const currentNode = tree[i];

        // 如果当前节点的code与要查找的code匹配，则返回当前节点
        if (currentNode.code === code) {
          return currentNode;
        }

        // 如果当前节点有子节点，则递归地在子节点中查找
        if (currentNode.children && currentNode.children.length > 0) {
          const foundNode = this.findRouteCode(currentNode.children, code);
          // 如果在子节点中找到了匹配的节点，则返回该节点
          if (foundNode) {
            return foundNode;
          }
        }
      }

      // 如果没有找到匹配的节点，则返回null
      return null;
    },
    initMenu() {
      let productTree = localStorage.getItem("menus");
      if (productTree) {
        productTree = JSON.parse(productTree);
      } else {
        productTree = [];
      }
      let menus = productTree;
      menus.forEach((v) => {
        this.$set(v, "subMenusShow", false);
      });
      this.newMenus = menus;
      let code = this.$route.meta.module;
      let arr1 = this.findRouteCode(this.newMenus, code);
      let defaultRegionId = localStorage.getItem("defaultRegionId");
      const query = {
        productId: arr1.id,
        regionId: defaultRegionId,
      };
      this.query = query;
      localStorage.setItem("query", JSON.stringify(query));
    },
  },
};
</script>

<style lang="scss" scoped>
.underLayer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  // z-index: 1;
}
.layout-container {
  height: 100%;
  // background: url('~@/assets/images/layout/bg01.png') no-repeat 0 0 / cover;
  overflow: hidden;
}

.layout-main {
  position: relative;
  overflow: hidden;
}

.bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  z-index: 2;
  background: url("~@/assets/images/layout/bigbj.png") no-repeat;
  background-size: 100% 100%;
  pointer-events: none;
}

.layout-header {
  position: absolute;
  text-align: center;
  width: 100%;
  height: 70px;
  display: flex;

  z-index: 2;

  .logo {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 15px;
  }

  .layout-sitename {
    margin: 0 auto;
  }

  .site-name {
    font-size: 40px;
    font-weight: 900;
    font-family: AlimamaShuHeiTi, serif;
    letter-spacing: 0.1em;
    background: linear-gradient(180deg, #d2ffee 0%, #e5fff5 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    margin-top: 10px;
  }
}

.layout-menu {
  position: absolute;
  top: 50%;
  width: 120px;
  transform: translateY(-50%);
  left: 4%;
  height: 560px;
  z-index: 2;

  .menus {
    position: absolute;
    background: url("~@/assets/images/layout/sideBorder.png") no-repeat;
    background-size: 100% 100%;
    width: 100px;
    padding: 10px;
    box-sizing: border-box;
    // .menusBox {
    //   max-height: 85vh;
    //   overflow-y: auto;
    // }
  }

  .menu-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 80px;
    color: #10b37c;
    margin-top: 10px;
    border-radius: 6px;
    background: url("~@/assets/images/layout/sideItem.png") no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    font-weight: 700;
    position: relative;
    box-sizing: border-box;

    .test {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 95px;
      width: 230px;
      background: #072117;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3),
        inset 0px 4px 60px 0px #004a2e;
      border-radius: 6px;
      border: 2px solid #18997d;
      padding: 18px 10px;
      box-sizing: border-box;

      .itembox {
        display: flex;
        flex-direction: column;
        max-height: 250px;
        overflow-y: auto;
        min-height: 50px;
      }

      .triangle {
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;
        border-left: 10px solid transparent;
        border-right: 10px solid #18997d;
        position: absolute;
        left: -20px;
        // top: min(50%,50px);
        top: 50%;
        transform: translateY(-50%);

        &::after {
          content: "";
          display: block;
          width: 0;
          height: 0;
          border-top: 10px solid transparent;
          border-bottom: 10px solid transparent;
          border-left: 10px solid transparent;
          border-right: 10px solid #033623;
          position: absolute;
          left: 0;
          top: 0;
          transform: translate(-7px, -10px);
        }
      }
    }

    &:last-of-type {
      margin-bottom: 0;
    }

    &:hover,
    &.active {
      background: url("~@/assets/images/layout/sideitemActive.png") no-repeat;
      background-size: 100% 100%;

      .menu-label {
        font-family: HarmonyOS_Sans_SC_Bold, serif;
        background: linear-gradient(180deg, #fff09e 18%, #11c58c 90%);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
      }
    }
  }

  .menu-icon {
    font-size: 20px;
    margin-right: 0;
    margin-bottom: 8px;
  }

  .menu-label {
    font-family: HarmonyOS_Sans_SC_Bold, serif;
    font-size: 16px;
  }

  .sub-menus {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    padding: 10px;
    margin-left: 100px;
    border-radius: 6px;
    background: #072117;

    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3),
      inset 0px 4px 60px 0px #004a2e;
  }

  .sub-menu-item {
    font-size: 16px;
    color: #fff;
    padding: 0 20px;
    padding-left: 10px;
    color: #17966b;
    transition: all 500ms;
    cursor: pointer;

    .line {
      background: linear-gradient(
        90deg,
        rgba(160, 235, 154, 0.2) -2%,
        rgba(160, 235, 154, 0) 98%
      );
      height: 1px;
      margin: 8px 0;
    }

    &.active,
    &:hover {
      .subMenusName {
        background: linear-gradient(180deg, #fff09e 50%, #11c58c 90%);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
      }

      .subMenusBg {
        background-image: linear-gradient(
          90deg,
          rgba(160, 235, 154, 0.2) -2%,
          rgba(160, 235, 154, 0) 98%
        );
      }
    }

    .subMenusName {
      line-height: 24px;
    }
  }
}

.layout-info {
  position: absolute;
  top: 6%;
  right: 75px;
  display: flex;
  z-index: 4;

  .iconBoxG {
    width: 24px;
    height: 24px;
    display: flex;
    margin-right: 3px;
    justify-content: center;
    align-items: center;
    background-color: rgba(9, 88, 47, 0.5);
    box-shadow: 0 0 20px 3px rgba(9, 88, 47, 1);

    .infoIcon {
      font-size: 16px;
    }
  }

  .account {
    font-family: HarmonyOS_Sans_SC_Regular, serif;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    color: #fff;
    padding: 0 10px;
    margin-left: 10px;
    font-size: 16px;
  }

  .remind-dialog {
    position: absolute;
    top: 37px;
    width: 600px;
    height: 320px;
    padding: 10px;
    border: 1px solid rgba(139, 177, 226, 0.4);
    border-radius: 4px;
    box-shadow: 0px 0px 10px 2px rgba(146, 159, 168, 0.4) inset;
    backdrop-filter: blur(4px);
    background-color: rgba(10, 23, 39, 0.9);
  }

  .fluorescent_green {
    font-family: HarmonyOS_Sans_SC_Regular, serif;
  }
}
</style>
